<template>
	<div>
		<div class="upload-box clearfix">
			<div class="upload-image" v-if="src">
				<image :src="src"></image>
			</div>
			<button class="btn-upload" @click="upLoadImage">
				<image src="@/static/images/icon-add.png"></image>
			</button>
		</div>
	</div>
</template>

<script>
	var _self
	export default {
		props:{
			src: {
				type: String,
				required: false
			}
		},
		data() {
			return {
			};
		},
		methods:{
			// 上传图片
			upLoadImage() {
                console.log('shangchuan')
				_self = this
				_self.$chooseImage({
					url: '/api/services/app/Attachment/UploadToTemp',
					success: function(res) {
						_self.$emit('imageInfo',res.result)
					}
				});
			},
		},
		created() {
            _self = this
        },
			
		
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/uploadImg.vue